import { render, staticRenderFns } from "./20201030.vue?vue&type=template&id=4d6488bd"
import script from "./20201030.vue?vue&type=script&lang=js"
export * from "./20201030.vue?vue&type=script&lang=js"
import style0 from "./20201030.vue?vue&type=style&index=0&id=4d6488bd&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports